<template>
  <v-snackbar
    v-model="SnackBarComponent.SnackbarVmodel"
    :color="SnackBarComponent.SnackbarColor"
    location="top"
    :timeout="3000"
  >
    <div class="text-center fontVariant2">
      {{ SnackBarComponent.SnackbarText }}
      <v-icon
        v-if="SnackBarComponent.close"
        class="ml-4"
        size="x-small"
        @click="SnackBarComponent.SnackbarVmodel = false"
        >mdi-close-circle</v-icon
      >
    </div>
  </v-snackbar>
</template>
<script>
export default {
  props: {
    SnackBarComponent: Object,
  },
};
</script>
